import React from 'react';
import { motion } from 'motion/react';

import { OnboardingQuestionConfig } from '@Models';

interface TrailEntry {
  step: OnboardingQuestionConfig;
  answer: string;
}

interface OnboardingTrailProps {
  entries: TrailEntry[];
}

const OnboardingTrail: React.FC<OnboardingTrailProps> = ({ entries }) => {
  if (entries.length === 0) return null;

  return (
    <div className="mb-8 space-y-3">
      {entries.map((entry) => (
        <motion.div
          key={entry.step.key}
          initial={{ opacity: 0.6 }}
          animate={{ opacity: 0.3 }}
          transition={{ duration: 0.5 }}>
          <p className="text-white/30 text-sm">{entry.step.question}</p>
          <p className="text-[#7c6cf6] text-sm font-medium">{entry.answer}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default OnboardingTrail;
export type { TrailEntry };
